import React from "react";
import { Link } from "react-router-dom";
import HeaderMain from "../Header/HeaderMain";
import FooterMain from "../Footer/FooterMain";
import "./NotFound.css";

/**
 * Catch-all route. Without this, any unknown URL matched no <Route> and React
 * Router rendered nothing at all — a blank white page for both visitors and
 * crawlers.
 */
function NotFound() {
  return (
    <>
      <HeaderMain />
      <main className="notfound">
        <div className="container notfound__inner">
          <p className="notfound__code">404</p>
          <h1 className="notfound__title">This page doesn&rsquo;t exist</h1>
          <p className="notfound__text">
            The link may be out of date, or the address mistyped. Here is where
            most people are heading:
          </p>
          <nav className="notfound__links" aria-label="Popular pages">
            <Link to="/" className="notfound__btn notfound__btn--primary">
              Back to home
            </Link>
            <Link to="/cadautomation" className="notfound__btn">
              CAD Automation
            </Link>
            <Link to="/staffing" className="notfound__btn">
              Staffing
            </Link>
            <Link to="/contact" className="notfound__btn">
              Contact us
            </Link>
          </nav>
        </div>
      </main>
      <FooterMain />
    </>
  );
}

export default NotFound;
